<template>
	<div>
		<div style="margin-bottom: 18px;margin-top: 18px;">
			<el-input v-model="title" placeholder="请输入标题" suffix-icon="el-icon-search" style="width: 200px;"
				size="small" @keyup.enter.native="getData"></el-input>

			<el-button type="primary" style="margin-left: 15px;" size="small" @click="getData">查询</el-button>
			<el-button type="success" style="margin-left: 15px;" size="small" @click="reset">重置</el-button>
			<el-button type="warning" style="margin-left: 15px;" size="small" @click="add">新增</el-button>
		</div>
		<el-table :data="tableData" :header-cell-style="{background:'#f2f5fc',color:'#55555'}" border
			highlight-current-row height="79vh">
			<el-table-column prop="id" align="center" label="ID" width="60">
			</el-table-column>
			<el-table-column prop="sub" align="center" label="标题(中文)" width="200">
			</el-table-column>
			<el-table-column prop="subEg" align="center" label="标题(英文)" width="200">
			</el-table-column>
			<el-table-column prop="content" align="center" label="内容(中文)" width="500">
			</el-table-column>
			<el-table-column prop="contentEg" align="center" label="内容(英文)" width="500">
			</el-table-column>
			<el-table-column prop="url" align="center" label="地址" width="500">
			</el-table-column>
			<el-table-column prop="img" align="center" label="图片" width="180">
				<template slot-scope="scope">
					<el-image style="width: 50px; height: 50px" :src="scope.row.image"  v-show="scope.row.srcList.length > 0"
						:preview-src-list="scope.row.srcList">
					</el-image>
				</template>
			</el-table-column>
			<!-- <el-table-column prop="sub" align="center" label="小标题(中文)" width="180">
			</el-table-column>
			<el-table-column prop="subEg" align="center" label="小标题(英文)" width="180">
			</el-table-column>
 -->
			<el-table-column prop="operate" align="center" label="操作" width="280">
				<template slot-scope="scope">
					<el-button type="success" size="small" @click="mod(scope.row)">编辑</el-button>
					<el-popconfirm title="确定删除吗？" @confirm="deleteRow(scope.row)"
						style="margin-left: 10px;">
						<el-button type="danger" slot="reference" size="small">删除</el-button>
					</el-popconfirm>

				</template>
			</el-table-column>
		</el-table>

		<div style="align-content: center;text-align: center;margin: 20px;">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
				:page-sizes="[2, 5, 14, 20]" :page-size="14" layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>
		</div>

		<el-dialog :title="textTitle" :visible.sync="centerDialogVisible" width="60%" center>
			<el-form ref="form" :model="form" :rules="rules" label-width="120px">

				<el-form-item label="所属样式" prop="account">
					<el-col :span="20">
						<el-select v-model="form.type" placeholder="请选择">
							<el-option v-for="item in options1" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-col>
				</el-form-item>

				<el-form-item label="标题(中文)" prop="sub">
					<el-col :span="20" style="border: 1px solid gray;">
						<tinymce-editor v-model="form.sub" :init="initEditor" />
					</el-col>
				</el-form-item>
				<el-form-item label="标题(英文)" prop="subEg">
					<el-col :span="20" style="border: 1px solid gray;">
						<tinymce-editor v-model="form.subEg" :init="initEditor" />
					</el-col>
				</el-form-item>

				<el-form-item label="内容(中文)" prop="content">
					<el-col :span="20" style="border: 1px solid gray;">
						<tinymce-editor v-model="form.content" :init="initEditor" />
					</el-col>
				</el-form-item>
				<el-form-item label="内容(英文)" prop="contentEg">
					<el-col :span="20" style="border: 1px solid gray;">
						<tinymce-editor v-model="form.contentEg" :init="initEditor" />
					</el-col>
				</el-form-item>

				<el-form-item label="地址" prop="url">
					<el-col :span="20">
						<el-input v-model="form.url"></el-input>
					</el-col>
				</el-form-item>

				<el-form-item label="图片" prop="url">
					<el-col :span="20">
						<!-- <el-input v-model="form.remark"></el-input> -->
						<el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false"
							:on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
							<img v-if="form.image" :src="form.image" class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且尺寸宽高比例为3:2</div>
						</el-upload>
					</el-col>
				</el-form-item>

			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="save">{{ btnText }}</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	import TinymceEditor from '../../components/TinymceEditor/index.vue';
	export default {
		name: "UserMange",
		components: {
			TinymceEditor
		},
		data() {
			return {
				rules: {
					title: [{
						required: true,
						message: '请输入名字',
						trigger: 'blur'
					}]
				},
				options1: [{
					value: 1,
					label: '样式一'
				}, {
					value: 2,
					label: '样式二'
				},
				// {
				// 	value: 3,
				// 	label: '样式三'
				// },
				{
					value: 4,
					label: '样式四'
				}],
				tableData: [],
				pageSize: 14,
				page: 1,
				total: 0,
				title: "",
				centerDialogVisible: false,
				form: {
					type: "",
					content: "",
					contentEg: "",
					subEg: "",
					url: "",
					image: ""
				},
				btnText: "提 交",
				textTitle: "新增右侧列表",
				isDis: false,
				user: JSON.parse(sessionStorage.getItem('CurUser')),
				uploadUrl: "https://zyjwsys.sxsla.cn/files/upload",
				fileList: [],
				fileList1: [],
				imageUrl: '',
				isShow: false,
				isShow1: false,
				isShow2: false,
			}
		},
		computed: {
			// 初始化富文本
			initEditor() {
				return {
					height: 300,
					branding: false,
					skin_url: '/tinymce/skins/ui/oxide',
					content_css: '/tinymce/skins/content/default/content.css',
					language_url: '/tinymce/langs/zh_CN.js',
					language: 'zh_CN',
					plugins: 'code print preview fullscreen paste searchreplace save autosave link autolink image imagetools media table codesample lists advlist hr charmap emoticons anchor directionality pagebreak quickbars nonbreaking visualblocks visualchars wordcount',
					toolbar: 'fullscreen preview code | undo redo | forecolor backcolor | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist | formatselect fontselect fontsizeselect | link image media emoticons charmap anchor pagebreak codesample | ltr rtl',
					toolbar_drawer: 'sliding',
					fontsize_formats: '8px 10px 12px 14px 18px 24px 36px 48px 60px 72px 80px 90px 100px 110px 120px 140px 180px',
					images_upload_handler: (blobInfo, success, error) => {
						let file = blobInfo.blob();
						// 使用axios上传
						const formData = new FormData();
						formData.append('file', file, file.name);
						this.$http.post('https://zyjwsys.sxsla.cn/files/upload', formData).then(res => {
							if (res.data.code == 0) {
								success(res.data.data);
							} else {
								error(res.data.msg);
							}
						}).catch(e => {
							console.error(e);
							error(e.message);
						});
					},
					file_picker_types: 'media',
					file_picker_callback: () => {}
				}
			}
		},
		beforeMount() {
			// this.utils.Logger("1111111111111111");
			this.getData();
			// this.loadPost();
		},
		methods: {
			changeShowType(index) {
				if (index == 1) {
					this.isShow = false;
					this.isShow1 = false;
					this.isShow2 = false;
				} else if (index == 2) {
					this.isShow = true;
					this.isShow1 = false;
					this.isShow2 = false;
				} else if (index == 3) {
					this.isShow = false;
					this.isShow1 = true;
					this.isShow2 = true;
				}
			},
			handleAvatarSuccess(res, file) {
				this.form.image = "https://image.sxsla.cn/files/" + res.data.name;
			},
			getImageSize(file) {
				return new Promise((resolve, reject) => {
					const reader = new FileReader()
					reader.onload = e => {
						const image = new Image()
						image.onload = () => {
							resolve({
								width: image.width,
								height: image.height
							})
						}
						image.src = e.target.result
					}
					reader.readAsDataURL(file)
				})
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;
				
				// if (!isJPG) {
				// 	this.$message.error('上传头像图片只能是 JPG 格式!');
				// }
				if (!isLt2M) {
					return this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				
				this.getImageSize(file).then(size => {
					if (size.width / size.height !== 1.5) {
						this.$message.error('宽高比例必须为3:2')
						return Promise.reject()
					}
				})
				// return isLt2M;
			},
			mod(row) {
				this.form = row;
				this.btnText = "保存";
				this.textTitle = '修改右侧列表'
				this.centerDialogVisible = true;
			},
			resetForm() {
				this.$refs.form.resetFields();
			},
			deleteRow(row){
				var that = this;
				this.utils.requestPost(this, "/subList/delete", {'id':row.id}, function(res, total) {
					that.getData();
					that.utils.showMessage("success", "删除成功");
				});
			},
			save() {
				var that = this;
				this.$refs.form.validate((valid) => {
					if (valid) {
						if (that.btnText == "提交") {
							this.utils.requestPost(this, "/subList/add", this.form, function(res, total) {
								that.centerDialogVisible = false;
								that.getData();
								that.utils.showMessage("success", "创建成功");
							});
						} else {
							this.utils.requestPost(this, "/subList/mod", this.form, function(res, total) {
								that.centerDialogVisible = false;
								that.getData();
								that.utils.showMessage("success", "修改成功");
							});
						}
					} else {
						that.utils.showMessage("error", "请输入正确的内容");
						return false;
					}
				});

			},
			add() {
				var that = this;
				this.btnText = "提交";
				this.textTitle = '添加右侧列表'
				this.centerDialogVisible = true;
				this.form = {
					type: "",
					content: "",
					contentEg: "",
					subEg: "",
					sub:"",
					url: "",
					image: ""
				};
				this.$nextTick(() => {
					that.resetForm();
				})
			},
			reset() {
				this.name = "";
			},
			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.getData();
			},
			handleCurrentChange(val) {
				this.page = val;
				this.getData();
			},
			getData() {
				var that = this;
				var params = {
					"pageSize": this.pageSize,
					"pageNum": this.page,
					"param": {
						"name": this.title
					}
				};
				this.utils.requestPost(this, "/subList/getDataList", params, function(res, total) {
					that.tableData = res;
					that.total = total;
				});
			}
		}
	}
</script>

<style scoped>
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>
